import { Badge, PageHeader, Panel } from '../../components/ui'
import { t } from '../../i18n'
import { Outbound } from './Outbound'
import { TelegramAccount } from './TelegramAccount'

/**
 * The settings screen.
 *
 * One panel of it is real — the Telegram account, which is the half an owner
 * actually has to touch — and the rest is still named rather than invented. A
 * placeholder padded out with plausible-looking switches gets mistaken for a
 * working screen, and the person who finds out otherwise loses an afternoon.
 */
export function Settings() {
  return (
    <div className="content__inner">
      <PageHeader title={t('settings.title')} />

      <TelegramAccount />

      {/*
        Above the placeholder, because it is the setting somebody comes to this
        screen for: it moves on its own when the account hiccups, and until it
        was here there was nowhere to put it back.
      */}
      <Outbound />

      <Panel className="placeholder">
        <section className="placeholder__section">
          <h2 className="placeholder__section-title">{t('placeholder.whatWillBeHere')}</h2>
          <p className="placeholder__lead">{t('settings.description')}</p>
        </section>

        <section className="placeholder__section">
          <h2 className="placeholder__section-title">{t('placeholder.whyEmpty')}</h2>
          <p className="placeholder__note">{t('placeholder.blockedOn')}</p>
          <Badge>{t('placeholder.badge')}</Badge>
        </section>

        <section className="placeholder__section">
          <h2 className="placeholder__section-title">{t('placeholder.needsEndpoints')}</h2>
          <ul className="endpoint-list">
            {['POST /api/settings/mode'].map(
              (endpoint) => (
                <li className="endpoint-list__item" key={endpoint}>
                  {endpoint}
                </li>
              ),
            )}
          </ul>
        </section>
      </Panel>
    </div>
  )
}
